import api from '@/utils/api';

/**
 * Update Company
 * @param {string} id Company id
 * @param {object} companyData - The Company data
 * @returns {Promise}
 */
const updateCompanyApi = (id, companyData) =>
  api.patch(`/company/${id}`, companyData);

export default updateCompanyApi;
